import AjaxService from "services/base/Ajax.service";

class OtherContactService extends AjaxService {
  async getOtherContacts() {
    return this.get("/otherContact");
  }

  async upsertOtherContact(data) {
    return this.post("/otherContact/upsert", data);
  }

  async createOtherContact(data) {
    return this.post("/otherContact/create", data);
  }

  async deleteOtherContact(otherContactId) {
    return this.delete(`/otherContact/${otherContactId}`);
  }

  async updateOtherContactProfile(otherContactId, data) {
    return this.put(`/otherContact/${otherContactId}/profile`, data);
  }

  async updateOtherContactLocations(otherContactId, locationIds) {
    return this.put(`/otherContact/${otherContactId}/locations`, {
      locationIds,
    });
  }

  async updateOtherContactSystems(otherContactId, systemIds) {
    return this.put(`/otherContact/${otherContactId}/systems`, { systemIds });
  }
}

export default new OtherContactService();
